import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import {useMdrdStore} from "@/store/models/mdrd-store";
import {computed, ref} from "vue";
import {Workbook} from 'exceljs';
import {saveAs} from 'file-saver-es';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {useFormaterStore} from "@/store/utility/formatter-store";
import {DateTime} from 'luxon';
import auth from "@/auth";
import notify from 'devextreme/ui/notify';

//import auth from "@/auth";

export const useDashboardStore = defineStore(
    'dashboard',
    () => {
        const tagBoxKelompokRef = ref(null);
        const isDashboardLoading = ref(false);
        const selectedKelompokScatter = ref(null);
        const tunggakanList = ref(null);

        const serverTime = computed(() => {
            return useMdrdStore().latestAccessTime;
        });

        const fileName = computed(() => {
            if (serverTime.value === null) {
                return 'rekap_data_tunggakan_';
            }

            return 'rekap_data_tunggakan_' + serverTime.value
                .replace(/[\s:-]/g, '_') // Replace whitespace, colons, and dashes with underscores
                .replace(/\./g, '');
        });

        const petugasSegelList = ref([]);

        const petugasSegelHeaderFilters = computed(() => {
            if (!petugasSegelList.value) {
                return [];
            }

            return petugasSegelList.value.map((item) => {
                return {
                    text: item.name,
                    value: ['petugas_segel', 'contains', item.name],
                };
            });
        });

        //provide dataSource called dataSourcePetugas segel. it just like petugasSegelHeaderFilters above, but taken from petugasSegelCustomStore
        const dataSourcePetugasSegel = ref(
            new DataSource({
                store: useMdrdStore().petugasSegelCustomStore,
            })
        );

        const datasourceTunggakan = ref(
            new DataSource({
                requireTotalCount: true,
                store: useMdrdStore().rekapTagihanCustomStore,
                /*onLoadingChanged: (isLoading) => {
                    isLoading.value = isLoading;
                }*/
            })
        );

        const initialize = () => {
            dataSourcePetugasSegel.value.load().then((values) => {
                petugasSegelList.value = values;
                console.log("VALUES", values); // Log the entire values object
                console.log("CALLED", petugasSegelList.value); // Log the assigned value
                console.log("CALLED2", petugasSegelHeaderFilters.value); // Log the computed value
            });
        };


        const onEditingStart = (e) => {
            if(!showEdit(e)){
                notify({
                    message:'PERIKSA HAK AKSES',
                    position: 'bottom center',
                }, 'error', 3000);
                e.cancel = true;
            }

            useMdrdStore().setSelectedEditingTindakLanjutRow(e.data);
        };

        const datasourceTugasSegel = ref(
            new DataSource({
                requireTotalCount: true,
                store: useMdrdStore().tugasSegelCustomStore,
                /*onLoadingChanged: (isLoading) => {
                    isLoading.value = isLoading;
                }*/
            })
        );


        const datasourceScatterTunggakan = ref(
            new DataSource({
                requireTotalCount: true,
                store: useMdrdStore().rekapTagihanScatterCustomStore,
                //filter: ["!", [["kelompok", "contains", "ABRI"], "and", ["kelompok", "contains", "POLRI"]]],
                onLoadingChanged: (isLoading) => {
                    isDashboardLoading.value = isLoading;
                },
                /*onChanged: (e) => {
                    //tunggakanList.value = e.data;
                    console.log( tunggakanList.value);
                }*/
            })
        );

        const dataSourceStatus = [
            {value: null, display: 'Semua'},
            {value: true, display: 'Sudah Ditindak'},
            {value: false, display: 'Belum Ditindak'}
        ];

        const dataSourceBarChartJmlTunggakanPerKelompok = ref(
            new DataSource({
                store: useMdrdStore().rekapTagihanBarChartCabangCustomStore,
                onLoadingChanged: (isLoading) => {
                    isDashboardLoading.value = isLoading;
                },
            })
        );

        const onExportingExcel = (e) => {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet(`cek_data_tunggakan`);
            const combinedFilter = e.component.getCombinedFilter();
            const filterCriteria = (combinedFilter === undefined || combinedFilter === null) ? 'Tanpa Filter' : combinedFilter;
            const filterString = JSON.stringify(filterCriteria);

            exportDataGrid({
                component: e.component,
                worksheet,
                topLeftCell: {row: 4, column: 1},
            }).then((cellRange) => {
                // header
                const headerRow = worksheet.getRow(2);
                headerRow.height = 30;
                worksheet.mergeCells(2, 1, 2, 8);

                headerRow.getCell(1).value = 'Data Tunggakan';
                headerRow.getCell(1).font = {name: 'Segoe UI Light', size: 18};
                headerRow.getCell(1).alignment = {horizontal: 'center'};

                const subtitleRow = worksheet.getRow(3);
                worksheet.mergeCells(3, 1, 3, 8);

                subtitleRow.getCell(1).value = `Tanggal Akses: ${serverTime.value}`;
                subtitleRow.getCell(1).font = {size: 12};
                subtitleRow.getCell(1).alignment = {horizontal: 'center'};

                // footer
                const footerRowIndex = cellRange.to.row + 2;
                const footerRow = worksheet.getRow(footerRowIndex);
                worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

                footerRow.getCell(1).value = `FILTER: ${filterString}`;
                footerRow.getCell(1).font = {italic: true};
                footerRow.getCell(1).alignment = {horizontal: 'left'};
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], {type: 'application/octet-stream'}), `${fileName.value}.xlsx`);
                });
            });
            e.cancel = true;
        };

        const selectionKelompokChanged = () => {
            datasourceScatterTunggakan.value.filter(convertedSelectedKelompokFilterExpression.value);
            datasourceScatterTunggakan.value.load();
            //console.log(JSON.stringify(datasourceScatterTunggakan.value.filter()));

        };

        const selectionBarChartKelompokChanged = () => {
            dataSourceBarChartJmlTunggakanPerKelompok.value.filter(convertedSelectedKelompokFilterExpression.value);
            dataSourceBarChartJmlTunggakanPerKelompok.value.load();
            //console.log(JSON.stringify(datasourceScatterTunggakan.value.filter()));
        };


        const convertedSelectedKelompokFilterExpression = computed(() => {
            if (selectedKelompokScatter.value === null) {
                selectedKelompokScatter.value = null;
                return null;
            } else if (selectedKelompokScatter.value.length === 0) {
                selectedKelompokScatter.value = null;
                return null;
            }
            const filterExpression = selectedKelompokScatter.value;
            const convertedExpression = [];
            for (let i = 0; i < filterExpression.length; i++) {
                const condition = filterExpression[i];
                if (Array.isArray(condition)) {
                    convertedExpression.push(condition);
                }
                if (i < filterExpression.length - 1) {
                    convertedExpression.push("or");
                }
            }

            return convertedExpression;
        });

        function tooltipScatter(pointInfo) {
            return {
                text: `${pointInfo.point.data.nosbg} (${pointInfo.point.data.jml_tunggakan} Rek) <br/>${useFormaterStore().priceFormat(pointInfo.point.data.jml_bayar)}<br/>${pointInfo.point.data.gol} | ${pointInfo.point.data.kelompok}`,
            };
        }


        const onChangedSelectedFilterTempoSampaiDengan = (data) => {
            const date = DateTime.fromJSDate(data.value).toFormat('yyyy-MM-dd');
            //useMdrdStore().setSelectedFilterTempoSampaiDengan(date);
            debouncedLoadTempoFiltering(date);
        };

        const onChangedSelectedFilterTanggalSegel = (data) => {
            const date = DateTime.fromJSDate(data.value).toFormat('yyyy-MM-dd');
            //useMdrdStore().setSelectedFilterTanggalSegel(date);
            debouncedLoadTempoFiltering(date);
        };

        const onChangedSelectedFilterTanggalCabut = (data) => {
            console.log("Cabut", data);
            const date = DateTime.fromJSDate(data.value).toFormat('yyyy-MM-dd');
            //useMdrdStore().setSelectedFilterTanggalCabut(date);
            debouncedLoadTempoFiltering(date);
        };

        const onChangedSelectedFilterLainLain = (data) => {
            // useMdrdStore().setSelectedFilterLainLain(data.value);
            debouncedLoadTempoFiltering(data.value);
        };

        const onChangedSelectedFilterStatus = (data) => {
            //useMdrdStore().setSelectedFilterStatus(data.value);
            debouncedLoadTempoFiltering(data.value);
        };

        function debounce(func, delay) {
            let debounceTimer;
            return function (...args) {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => func.apply(this, args), delay);
            };
        }

        //const debouncedLoadTempoFiltering = debounce(loadTempoFiltering, 1100);
        const debouncedLoadTempoFiltering = debounce(() => loadTempoFiltering(), 1100);

        function loadTempoFiltering() {
            //console.log(data);
            datasourceTunggakan.value.reload();
        }

        function onRowPrepared(e) {
            if (e.rowType === 'data' && e.data) {

                // lebih dari jatuh tempo
                const tanggalTempo = DateTime.fromISO(e.data.tanggal_tempo);
                const today = DateTime.now();

                // belum ditindak dan lebih dari atau samadengan 3 bulan
                if (e.data.status === false && e.data.jml_tunggakan >= 3) {
                    e.rowElement.style.backgroundColor = useFormaterStore().bgColorYellow;
                }

                // belum ditindak dan lebih dari atau samadengan 3 bulan
                if (e.data.status === false && e.data.jml_tunggakan >= 5) {
                    e.rowElement.style.backgroundColor = useFormaterStore().bgColorRed;
                }

                if (tanggalTempo < today && e.data.tanggal_segel == null && e.data.tanggal_cabut == null) {
                    if (e.data.jml_tunggakan >= 3) {
                        e.rowElement.style.backgroundColor = useFormaterStore().bgColorYellow; // Example color for dates in the future
                    }

                    if (e.data.jml_tunggakan >= 5) {
                        e.rowElement.style.backgroundColor = useFormaterStore().bgColorRed; // Example color for dates in the future
                    }
                    e.rowElement.style.fontWeight = 'bold';
                }

                // belum ditindak dan lebih dari atau samadengan 3 bulan
                if (e.data.tanggal_segel !== null) {
                    e.rowElement.style.backgroundColor = useFormaterStore().bgColorAqua;
                }

                if (e.data.tanggal_cabut !== null) {
                    e.rowElement.style.backgroundColor = useFormaterStore().bgColorGreen;
                }
            }
        }


        const showEdit = (rowData) => {
            var allowedRayon = auth.getUserAllowedRayons();
            var rayon = rowData.data.rayon;
            var isEditAllowed = false;
            var role = auth.getUserRoleId();

            if (allowedRayon.includes(rayon) || role === 1 ) {
                isEditAllowed = true;
            }

            //console.log(allowedRayon);
            //console.log(rayon);

            return isEditAllowed; // Or false based on your condition
        }

        return {
            onChangedSelectedFilterTempoSampaiDengan,
            onChangedSelectedFilterTanggalSegel,
            onChangedSelectedFilterTanggalCabut,
            onChangedSelectedFilterLainLain,
            onChangedSelectedFilterStatus,
            datasourceTunggakan,
            isDashboardLoading,
            /*rayonHeaderFilters,
            kelompokHeaderFilters,
            golonganHeaderFilters,*/
            onExportingExcel,
            serverTime,
            fileName,
            datasourceScatterTunggakan,
            selectionKelompokChanged,
            selectedKelompokScatter,
            tagBoxKelompokRef,
            tooltipScatter,
            convertedSelectedKelompokFilterExpression,
            tunggakanList,
            dataSourceBarChartJmlTunggakanPerKelompok,
            selectionBarChartKelompokChanged,
            dataSourceStatus,
            onEditingStart,
            onRowPrepared,
            showEdit,
            datasourceTugasSegel,
            petugasSegelHeaderFilters,
            initialize,
        }
    }
);